<!--
 * @Author: Asadhcj asadhcj@163.com
 * @Date: 2025-09-05 10:01:59
 * @LastEditors: Asadhcj asadhcj@163.com
 * @LastEditTime: 2026-01-07 13:38:07
 * @FilePath: \betdoce-admind:\new_project\betdoce-web\src\components\LoginDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <v-dialog
    transition="dialog-bottom-transition"
    v-model="show"
    :max-width="isMobile ? '100%' : '850'"
    class="login-dialog"
    :persistent="false"
    @click:outside="handleClose"
  >
    <div class="login-card" :class="{ mobile: isMobile }">
      <!-- 标题 -->
      <!-- <div style="text-align: right">
        <v-btn
          class="close-btn"
          icon="mdi-close"
          variant="text"
          @click="show = false"
        ></v-btn>
      </div> -->
      <!-- 登录方式切换 -->
      <div
        class="login-tabs d-flex flex-center"
        :style="!isPasswordLogin ? 'display: flex;' : ''"
      >
        <div
          class="d-flex mb-10"
          v-if="!isForgotPasswordMode"
          style="border-radius: 32px; background-color: rgb(33, 33, 33)"
        >
          <v-btn
            class="login-title-sign"
            value="sign"
            :class="{ activeTabBg: toggleModeBtn === 'sign' }"
          >
            <div
              class="login-title"
              style="flex: 1"
              v-if="isPasswordLogin"
              @click="toggleMode"
            >
              {{ "Registro" }}
            </div>
          </v-btn>
          <v-btn
            class="login-title-login"
            value="login"
            :class="{ activeTabBg: toggleModeBtn === 'login' }"
          >
            <div
              class="login-title"
              style="flex: 1"
              v-if="isPasswordLogin"
              @click="toggleMode"
            >
              {{ "Entrar" }}
            </div>
          </v-btn>
        </div>
        <template v-else>
          <div class="login-title-forget" v-if="isPasswordLogin">
            {{ "Redefinir senha" }}
          </div>
        </template>
        <v-btn
          v-if="!isPasswordLogin"
          :class="['tab-btn', { active: activeTab === 'phone' }]"
          variant="text"
          :ripple="false"
          @click="activeTab = 'phone'"
        >
          Telefone
        </v-btn>
      </div>
      <template v-if="isPasswordLogin">
        <!-- 手机号输入 -->
        <v-text-field
          v-model="phone"
          variant="outlined"
          density="comfortable"
          hide-details
          :label="
            isForgotPasswordMode
              ? 'Número de telefone celular'
              : 'Número de telefone celular'
          "
          class="phone-input"
          placeholder="Digite seu número de celular"
          bg-color="#1F2937"
          ref="textField"
          @click:control="handleInputClick"
        >
          <template #prepend-inner>
            <span class="prefix">+55</span>
          </template>
          <template #append-inner>
            <v-btn
              v-if="phone"
              variant="text"
              icon
              size="small"
              class="clear-btn"
              @click="clearPhone"
            >
              <v-icon color="rgba(255,255,255,0.5)" size="small"
                >mdi-close-circle</v-icon
              >
            </v-btn>
          </template>
        </v-text-field>

        <!-- 验证码输入 (忘记密码模式) -->
        <div class="code-input-wrapper" v-if="isForgotPasswordMode">
          <v-text-field
            v-model="verificationCode"
            variant="outlined"
            density="comfortable"
            hide-details
            class="code-input"
            placeholder="Código de verificação"
            bg-color="#1F2937"
          >
            <template #append-inner>
              <v-btn
                variant="text"
                class="send-code-btn"
                :disabled="countdown > 0"
                @click="sendCode"
              >
                <span>{{ countdown > 0 ? `${countdown}s` : "Enviar" }}</span>
              </v-btn>
            </template>
          </v-text-field>

          <!-- 新密码输入 -->
          <v-text-field
            v-model="newPassword"
            variant="outlined"
            density="comfortable"
            label="Nova Senha"
            hide-details
            :type="showPasswordFlag ? 'text' : 'password'"
            class="code-input"
            placeholder="Digite sua nova senha"
            bg-color="#1F2937"
          >
            <template #prepend-inner>
              <v-icon
                color="rgba(255,255,255,0.7)"
                size="small"
                class="lock-icon"
                >mdi-shield-lock-outline</v-icon
              >
            </template>
            <template #append-inner>
              <v-btn
                v-if="newPassword"
                variant="text"
                icon
                size="small"
                class="clear-btn"
                @click="clearNewPassword"
              >
                <v-icon color="rgba(255,255,255,0.5)" size="small"
                  >mdi-close-circle</v-icon
                >
              </v-btn>
              <v-btn variant="text" class="show-pass-btn" @click="showPassword">
                <v-icon
                  color="rgba(255,255,255,0.7)"
                  size="small"
                  class="lock-icon"
                  >{{
                    showPasswordFlag ? "mdi-eye-outline" : "mdi-eye-off-outline"
                  }}</v-icon
                >
              </v-btn>
            </template>
          </v-text-field>

          <!-- 确认新密码输入 -->
          <v-text-field
            v-model="confirmNewPassword"
            variant="outlined"
            density="comfortable"
            label="Confirmar nova senha"
            hide-details
            :type="showConfirmPasswordFlag ? 'text' : 'password'"
            class="code-input"
            placeholder="Digite a senha de confirmação"
            bg-color="#1F2937"
          >
            <template #prepend-inner>
              <v-icon
                color="rgba(255,255,255,0.7)"
                size="small"
                class="lock-icon"
                >mdi-shield-lock-outline</v-icon
              >
            </template>
            <template #append-inner>
              <v-btn
                v-if="confirmNewPassword"
                variant="text"
                icon
                size="small"
                class="clear-btn"
                @click="clearConfirmNewPassword"
              >
                <v-icon color="rgba(255,255,255,0.5)" size="small"
                  >mdi-close-circle</v-icon
                >
              </v-btn>
              <v-btn
                variant="text"
                class="show-pass-btn"
                @click="showConfirmPassword"
              >
                <v-icon
                  color="rgba(255,255,255,0.7)"
                  size="small"
                  class="lock-icon"
                  >{{
                    showConfirmPasswordFlag
                      ? "mdi-eye-outline"
                      : "mdi-eye-off-outline"
                  }}</v-icon
                >
              </v-btn>
            </template>
          </v-text-field>
        </div>

        <!-- 普通登录/注册模式 -->
        <div class="code-input-wrapper" v-else>
          <v-text-field
            v-model="password"
            variant="outlined"
            density="comfortable"
            label="Senha"
            hide-details
            :type="showPasswordFlag ? 'text' : 'password'"
            class="code-input"
            placeholder="Digite sua senha"
            bg-color="#1F2937"
          >
            <template #prepend-inner>
              <v-icon
                color="rgba(255,255,255,0.7)"
                size="small"
                class="lock-icon"
                >mdi-shield-lock-outline</v-icon
              >
            </template>
            <template #append-inner>
              <v-btn
                v-if="password"
                variant="text"
                icon
                size="small"
                class="clear-btn"
                @click="clearPassword"
              >
                <v-icon color="rgba(255,255,255,0.5)" size="small"
                  >mdi-close-circle</v-icon
                >
              </v-btn>
              <v-btn
                variant="text"
                class="show-pass-btn"
                :disabled="countdown > 0"
                @click="showPassword"
              >
                <v-icon
                  color="rgba(255,255,255,0.7)"
                  size="small"
                  class="lock-icon"
                  >{{
                    showPasswordFlag ? "mdi-eye-outline" : "mdi-eye-off-outline"
                  }}</v-icon
                >
              </v-btn>
            </template>
          </v-text-field>

          <!-- 确认密码输入 (仅注册模式显示) -->
          <v-text-field
            v-if="isSignUpMode"
            v-model="confirmPassword"
            variant="outlined"
            density="comfortable"
            label="Confirmar senha"
            hide-details
            :type="showConfirmPasswordFlag ? 'text' : 'password'"
            class="code-input"
            placeholder="Digite a senha de confirmação"
            bg-color="#1F2937"
          >
            <template #prepend-inner>
              <v-icon
                color="rgba(255,255,255,0.7)"
                size="small"
                class="lock-icon"
                >mdi-shield-lock-outline</v-icon
              >
            </template>
            <template #append-inner>
              <v-btn
                v-if="confirmPassword"
                variant="text"
                icon
                size="small"
                class="clear-btn"
                @click="clearConfirmPassword"
              >
                <v-icon color="rgba(255,255,255,0.5)" size="small"
                  >mdi-close-circle</v-icon
                >
              </v-btn>
              <v-btn
                variant="text"
                class="show-pass-btn"
                :disabled="countdown > 0"
                @click="showConfirmPassword"
              >
                <v-icon
                  color="rgba(255,255,255,0.7)"
                  size="small"
                  class="lock-icon"
                  >{{
                    showConfirmPasswordFlag
                      ? "mdi-eye-outline"
                      : "mdi-eye-off-outline"
                  }}</v-icon
                >
              </v-btn>
            </template>
          </v-text-field>

          <div class="remember-forgot" v-if="!isSignUpMode">
            <v-checkbox
              v-model="rememberChecked"
              label="lembrar"
              color="#49C973"
              class="remember-checkbox"
            />
            <span class="forgot-password" @click="toggleForgotPasswordMode"
              >esqueça a senha?</span
            >
          </div>
        </div>
        <!-- 登录/注册/重置密码按钮 -->
        <v-btn
          block
          size="large"
          class="login-btn"
          :class="{ 'active-login-btn': activityBtn() }"
          :loading="loading"
          :disabled="loading"
          @click="handlePrimaryAction"
          @pointerup="handlePrimaryAction"
        >
          {{
            isForgotPasswordMode
              ? "Redefinir senha"
              : isSignUpMode
              ? "Registro"
              : "Entrar"
          }}
        </v-btn>
        <div class="sing-up-bottom" v-if="!isForgotPasswordMode">
          <v-checkbox
            v-model="tipsChecked"
            label="Declaro que tenho mais de 18 anos e aceito a Política de Privacidade e os Termos e Condições."
            color="#49C973"
            readonly
            class="tips-checkbox"
          />

          <!-- <span class="sign-up-btn" @click="toggleMode">{{
            isSignUpMode ? "Entrar" : "Registro"
          }}</span> -->
        </div>
        <div class="sing-up-bottom" v-else>
          <span class="sign-up-btn" @click="toggleForgotPasswordMode"
            >Voltar ao login</span
          >
        </div>
      </template>
      <template v-if="!isPasswordLogin">
        <!-- 手机号输入 -->
        <v-text-field
          v-model="phone"
          variant="outlined"
          density="comfortable"
          hide-details
          label="Número de telefone celular"
          class="phone-input"
          placeholder="Digite seu número de celular"
          bg-color="#1F2937"
          ref="textField"
          @click:control="handleInputClick"
        >
          <template #prepend-inner>
            <span class="prefix">+55</span>
          </template>
          <template #append-inner>
            <v-btn
              v-if="phone"
              variant="text"
              icon
              size="small"
              class="clear-btn"
              @click="clearPhone"
            >
              <v-icon color="rgba(255,255,255,0.5)" size="small"
                >mdi-close-circle</v-icon
              >
            </v-btn>
          </template>
        </v-text-field>

        <!-- 验证码输入 -->
        <div class="code-input-wrapper">
          <v-text-field
            v-model="verificationCode"
            variant="outlined"
            density="comfortable"
            hide-details
            class="code-input"
            placeholder="Código de verificação"
            bg-color="#1F2937"
          >
            <template #append-inner>
              <v-btn
                variant="text"
                class="send-code-btn"
                :disabled="countdown > 0"
                @click="sendCode"
              >
                <span>{{ countdown > 0 ? `${countdown}s` : "Enviar" }}</span>
              </v-btn>
            </template>
          </v-text-field>
        </div>
        <!-- <v-text-field v-model="password" variant="outlined" density="comfortable" label="Password" hide-details
            :type="showPasswordFlag ? 'text' : 'password'" class="code-input" placeholder="Enter your password"
            bg-color="#1F2937">
            <template #prepend-inner>
              <v-icon color="rgba(255,255,255,0.7)" size="small" class="lock-icon">mdi-shield-lock-outline</v-icon>
            </template>
            <template #append-inner>
              <v-btn variant="text" class="show-pass-btn" :disabled="countdown > 0" @click="showPassword">
                <v-icon color="rgba(255,255,255,0.7)" size="small" class="lock-icon">{{ showPasswordFlag ?
                  'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
              </v-btn>
            </template>
          </v-text-field> -->

        <!-- 确认密码输入 (仅注册模式显示) -->
        <!-- <v-text-field v-if="isSignUpMode" v-model="confirmPassword" variant="outlined" density="comfortable"
            label="Confirm Password" hide-details type="password" class="code-input" placeholder="Confirm your password"
            bg-color="#1F2937">
            <template #prepend-inner>
              <v-icon color="rgba(255,255,255,0.7)" size="small" class="lock-icon">mdi-shield-lock-outline</v-icon>
            </template>
          </v-text-field>

          <div class="remember-forgot" v-if="!isSignUpMode">
            <v-checkbox v-model="showPasswordFlag" label="lembrar" color="#49C973" class="remember-checkbox" />
            <span class="forgot-password">esqueça a senha?</span>
          </div>
        </div> -->
        <!-- 登录/注册按钮 -->
        <v-btn
          block
          size="large"
          class="login-btn"
          :loading="loading"
          @click="isSignUpMode ? handleSignUp() : handleLogin()"
        >
          {{ isSignUpMode ? "Registro" : "Entrar" }}
        </v-btn>
        <!-- <div class="sing-up-bottom">
          {{ isSignUpMode ? 'Já tem uma conta？' : "Nenhuma conta ainda?" }}
          <span class="sign-up-btn" @click="toggleMode">{{ isSignUpMode ? 'Entrar' : 'Registro' }}</span>
        </div> -->
      </template>
    </div>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { showError, showSuccess, showInfo } from "@/utils/toast";
import { normalizeRequestParams, md5Encrypt } from "@/utils";
import { setToken } from "@/utils/auth";
import { getAndClearTargetRoute } from "@/utils/auth";
import websocketService from "@/utils/websocket";
import { parseUrlParams } from "@/utils/url";
import { getShortLinkDetail, loginDevice, resetPassword } from "@/api/auth";
import { eventBus, LOGIN_EVENTS } from "@/utils/eventBus";
import { generateDeviceFingerprint } from "@/utils/device";
import { GoogleTag } from "@/utils/auth";

const store = useStore();
const router = useRouter();
const textField = ref();
const isPasswordLogin = ref(
  import.meta.env.VITE_IS_PASSWORD_LOGIN === "true" ? true : false
);

// 使用自定义的设备检测逻辑
const isMobile = computed(() => {
  return window.innerWidth <= 768;
});

function getDeviceCode() {
  const userAgent = navigator.userAgent;
  let deviceCode = 0; // Default to 0 if no match is found

  const devicePatterns = {
    "1": /Windows NT/i, // PC-Windows
    "2": /Macintosh/i, // PC-MacOS
    "3": /iPhone|iPad|iPod/i, // H5-iOS
    "4": /Android/i, // H5-Android
  };

  for (const [code, pattern] of Object.entries(devicePatterns)) {
    if (pattern.test(userAgent)) {
      deviceCode = parseInt(code);
      break;
    }
  }

  return deviceCode;
}

const props = defineProps<{
  modelValue: boolean;
  isLogin?: boolean;
}>();
const origin_link = ref("");
const activityObj = ref<{
  activity_id?: string | number;
  invite_code?: string;
  channel?: string;
  agent_invite_code?: string;
  pdd_invite_code?: string;
}>({});

// 定义ShortLinkResponse接口
interface ShortLinkResponse {
  origin_link?: string;
  [key: string]: any;
}
const emit = defineEmits(["update:modelValue", "login"]);

const show = ref(props.modelValue);
const activeTab = ref("phone");
const phone = ref("");
const verificationCode = ref("");
const password = ref("");
const loading = ref(false);
const uiReady = ref(false);
const lastPrimaryActionAt = ref(0);
const countdown = ref(0);
const showPasswordFlag = ref(false);
const showConfirmPasswordFlag = ref(false);

const rememberChecked = ref(false);
const tipsChecked = ref(true);

// 记住密码相关的常量
const REMEMBER_PASSWORD_KEY = "remembered_password";
const REMEMBER_PHONE_KEY = "remembered_phone";
const REMEMBER_CHECKED_KEY = "remember_checked";
const isSignUpMode = ref(true);
const toggleModeBtn = ref("sign");
const confirmPassword = ref("");
const isForgotPasswordMode = ref(false);
const newPassword = ref("");
const confirmNewPassword = ref("");

// 组件挂载时恢复记住的密码
onMounted(() => {
  const setReady = () => {
    uiReady.value = true;
  };
  if (document.readyState === "complete") {
    setReady();
  } else {
    window.addEventListener("load", setReady, { once: true });
    setTimeout(setReady, 2500);
  }
  restoreRememberedPassword();
});

const handlePrimaryAction = async () => {
  const now = Date.now();
  if (now - lastPrimaryActionAt.value < 600) return;
  lastPrimaryActionAt.value = now;

  if (!uiReady.value) {
    showInfo("Carregando recursos, aguarde...");
    return;
  }
  if (loading.value) return;
  if (isForgotPasswordMode.value) {
    await handleResetPassword();
  } else if (isSignUpMode.value) {
    await handleSignUp();
  } else {
    await handleLogin();
  }
};

// 恢复记住的密码
const restoreRememberedPassword = () => {
  const rememberedChecked = localStorage.getItem(REMEMBER_CHECKED_KEY);
  if (rememberedChecked === "true" && props.isLogin) {
    isSignUpMode.value = false;
    toggleModeBtn.value = "login";
    rememberChecked.value = true;
    const rememberedPhone = localStorage.getItem(REMEMBER_PHONE_KEY);
    const rememberedPassword = localStorage.getItem(REMEMBER_PASSWORD_KEY);

    if (rememberedPhone) {
      phone.value = rememberedPhone;
    }
    if (rememberedPassword) {
      password.value = rememberedPassword;
    }
  }
};

// 保存密码到本地存储
const savePasswordToStorage = () => {
  if (rememberChecked.value) {
    localStorage.setItem(REMEMBER_PHONE_KEY, phone.value);
    localStorage.setItem(REMEMBER_PASSWORD_KEY, password.value);
    localStorage.setItem(REMEMBER_CHECKED_KEY, "true");
  } else {
    // 如果未勾选记住密码，清除已保存的密码
    localStorage.removeItem(REMEMBER_PHONE_KEY);
    localStorage.removeItem(REMEMBER_PASSWORD_KEY);
    localStorage.removeItem(REMEMBER_CHECKED_KEY);
  }
};

// 重置弹窗状态到初始登录模式
const resetDialogToLoginMode = () => {
  // 重置所有模式状态
  isSignUpMode.value = props.isLogin ? false : true;
  toggleModeBtn.value = props.isLogin ? "login" : "sign";
  isForgotPasswordMode.value = false;
  activeTab.value = "phone";
  countdown.value = 0;

  // 清空表单数据
  phone.value = "";
  password.value = "";
  verificationCode.value = "";
  newPassword.value = "";
  confirmNewPassword.value = "";

  confirmPassword.value = "";
  // 检查并恢复记住的账号密码
  restoreRememberedPassword();
};

// 监听 modelValue 变化
watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      // 每次打开弹窗时重置到登录模式
      resetDialogToLoginMode();
    }
    
    if (localStorage.getItem("inviteCode")) {
      getShortLinkDetail(localStorage.getItem("inviteCode") || "")
        .then((res) => {
          const shortLinkRes = res as ShortLinkResponse;
          origin_link.value = shortLinkRes?.origin_link || "";
          if (origin_link.value) {
            activityObj.value = parseUrlParams(origin_link.value);
            // 存储解析后的参数
            // console.log(activityObj.value);
            // console.log(
            //   activityObj.value?.invite_code &&
            //     !Number(activityObj.value?.activity_id)
            // );
          }
          show.value = val;
          // 检查是否需要打开注册模式（这是唯一的例外情况）
          if (val && sessionStorage.getItem("openRegisterMode") === "true") {
            isSignUpMode.value = true;
            toggleModeBtn.value = "sign";
            sessionStorage.removeItem("openRegisterMode"); // 使用后清除标识
          }
        })
        .catch((err) => {
          show.value = val;
          // 检查是否需要打开注册模式（这是唯一的例外情况）
          if (val && sessionStorage.getItem("openRegisterMode") === "true") {
            isSignUpMode.value = true;
            toggleModeBtn.value = "sign";
            sessionStorage.removeItem("openRegisterMode"); // 使用后清除标识
          }
        });
    } else {
      show.value = val;
      // 检查是否需要打开注册模式（这是唯一的例外情况）
      if (val && sessionStorage.getItem("openRegisterMode") === "true") {
        isSignUpMode.value = true;
        toggleModeBtn.value = "sign";
        sessionStorage.removeItem("openRegisterMode"); // 使用后清除标识
      }
    }
  }
);

// 监听 show 变化
watch(show, (val) => {
  emit("update:modelValue", val);
});

// 验证手机号
const validatePhone = (phone: string) => {
  if (!phone) {
    showError("Por favor, insira seu número de telefone");
    return false;
  }
  // 验证巴西手机号格式：10-11位数字
  const phoneRegex = /^[0-9]{10,11}$/;
  if (!phoneRegex.test(phone)) {
    showError("O número de telefone deve ter entre 10 e 11 dígitos");
    return false;
  }
  return true;
};

// 验证验证码
const validateCode = (code: string) => {
  if (!code) {
    showError("Por favor, insira o código de verificação");
    return false;
  }
  if (code.length !== 6) {
    showError("O código de verificação deve ter 6 dígitos");
    return false;
  }
  if (!/^\d+$/.test(code)) {
    showError("O código de verificação deve conter apenas números");
    return false;
  }
  return true;
};

// 发送验证码
const sendCode = async () => {
  if (countdown.value > 0) {
    showError(`Aguarde ${countdown.value} segundos para enviar novamente`);
    return;
  }

  if (!validatePhone(phone.value)) return;

  try {
    loading.value = true;
    const { deviceId } = await generateDeviceFingerprint();
    const fingerprint = md5Encrypt(deviceId);
    let res = await store.dispatch("auth/sendVerificationCode", {
      type: activeTab.value === "phone" ? "indiahm_sms" : "waotp",
      phone: phone.value,
      md5: fingerprint,
    });
    // verificationCode.value = res?.content || "";
    showSuccess("Código enviado com sucesso");
    countdown.value = 60;
    const timer = setInterval(() => {
      countdown.value--;
      if (countdown.value <= 0) {
        clearInterval(timer);
      }
    }, 1000);
  } catch (error: any) {
    showError(error || "Falha ao enviar código");
  } finally {
    loading.value = false;
  }
};
// 输入框点击事件
const handleInputClick = () => {};

// 切换密码显示状态
const showPassword = () => {
  showPasswordFlag.value = !showPasswordFlag.value;
};

// 切换确认密码显示状态
const showConfirmPassword = () => {
  showConfirmPasswordFlag.value = !showConfirmPasswordFlag.value;
};
// 清除手机号
const clearPhone = () => {
  phone.value = "";
};

// 清除密码
const clearPassword = () => {
  password.value = "";
};

// 清除新密码
const clearNewPassword = () => {
  newPassword.value = "";
};

// 清除确认新密码
const clearConfirmNewPassword = () => {
  confirmNewPassword.value = "";
};

// 清除确认密码
const clearConfirmPassword = () => {
  confirmPassword.value = "";
};

// 切换登录/注册模式
const toggleMode = () => {
  isSignUpMode.value = !isSignUpMode.value;
  toggleModeBtn.value = isSignUpMode.value ? "sign" : "login";
  // 清空表单数据
  phone.value = "";
  password.value = "";
  confirmPassword.value = "";
  verificationCode.value = "";
};

// 切换忘记密码模式
const toggleForgotPasswordMode = () => {
  isForgotPasswordMode.value = !isForgotPasswordMode.value;
  // 清空表单数据
  phone.value = "";
  password.value = "";
  verificationCode.value = "";
  newPassword.value = "";
  confirmNewPassword.value = "";
  countdown.value = 0;
};

// 验证新密码
const validateNewPassword = (
  newPassword: string,
  confirmNewPassword: string
) => {
  if (!newPassword) {
    showError("Por favor, insira a nova senha");
    return false;
  }
  if (newPassword.length < 8) {
    showError("A nova senha deve ter pelo menos 8 caracteres");
    return false;
  }
  if (newPassword.length > 20) {
    showError("A nova senha deve ter no máximo 20 caracteres");
    return false;
  }
  if (!confirmNewPassword) {
    showError("Por favor, confirme a nova senha");
    return false;
  }
  if (newPassword !== confirmNewPassword) {
    showError("As senhas não coincidem");
    return false;
  }
  return true;
};

// 处理重置密码
const handleResetPassword = async () => {
  if (
    !validatePhone(phone.value) ||
    !validateCode(verificationCode.value) ||
    !validateNewPassword(newPassword.value, confirmNewPassword.value)
  ) {
    return;
  }

  try {
    loading.value = true;
    const params = {
      account_name: phone.value,
      password: newPassword.value,
      code: verificationCode.value,
    };

    const success = await resetPassword(params);
    if (success) {
      showSuccess("Senha redefinida com sucesso");
      // 重置表单并返回登录模式
      phone.value = "";
      verificationCode.value = "";
      newPassword.value = "";
      confirmNewPassword.value = "";
      countdown.value = 0;
      isForgotPasswordMode.value = false;
    }
  } catch (error: any) {
    console.log(error);
    showError(error || "Falha ao redefinir senha");
  } finally {
    loading.value = false;
  }
};

// 验证确认密码
const validateConfirmPassword = (password: string, confirmPassword: string) => {
  if (!confirmPassword) {
    showError("Por favor, confirme sua senha");
    return false;
  }
  if (password !== confirmPassword) {
    showError("As senhas não coincidem");
    return false;
  }
  return true;
};

// 验证密码
const validatePassword = (password: string) => {
  if (!password) {
    showError("Por favor, insira sua senha");
    return false;
  }
  if (password.length < 8) {
    showError("A senha deve ter pelo menos 8 caracteres");
    return false;
  }
  if (password.length > 20) {
    showError("A senha deve ter no máximo 20 caracteres");
    return false;
  }
  return true;
};

// 处理注册
const handleSignUp = async () => {
  if (
    !validatePhone(phone.value) ||
    !validatePassword(password.value) ||
    !validateConfirmPassword(password.value, confirmPassword.value)
  ) {
    return;
  }
  try {
    loading.value = true;
    const { deviceId } = await generateDeviceFingerprint();
    const fingerprint = md5Encrypt(deviceId);
    const Fingerprint: any = localStorage.getItem("Fingerprint");
    let params: any = {
      account_name: phone.value,
      password: password.value,
      login_method: 4, // 密码登录
      source: getDeviceCode(),
      md5: fingerprint,
      code: "000000",
      pwa_channel_id: sessionStorage.getItem("promote_url_id") || "",
      fingerprint: {
        request_id: JSON.parse(Fingerprint).requestId,
        visitor_id: JSON.parse(Fingerprint).visitorId,
      },
    };
    // 判断是否有活动id
    if (Number(activityObj.value?.activity_id)) {
      params.activity_id = parseInt(activityObj.value?.activity_id as string);
      params.source_code = activityObj.value?.invite_code;
    }
    // 判断是否有渠道id
    if (activityObj.value?.channel) {
      params.channel = localStorage.getItem("inviteCode");
    }

    // 判断是否有代理商邀请码
    if (activityObj.value?.agent_invite_code) {
      params.agent_invite_code = activityObj.value?.agent_invite_code;
    }

    const success = await store.dispatch("auth/userRegister", params);
    if (success) {
      console.log(success, 4312421421);
      // 注册埋点
      await GoogleTag("102");
      // 保存密码到本地存储（如果勾选了记住密码）
      savePasswordToStorage();

      // Reset form
      phone.value = "";
      password.value = "";
      confirmPassword.value = "";
      countdown.value = 0;
      // Close dialog
      emit("update:modelValue", false);
      emit("login");
      handleClose();
      // 触发登录成功事件
      eventBus.emit(LOGIN_EVENTS.LOGIN_SUCCESS);
      if (
        !activityObj.value?.pdd_invite_code &&
        localStorage.getItem("inviteCode")
      ) {
        localStorage.removeItem("inviteCode");
      }
      localStorage.setItem("isLogin", "true");
      // 获取目标路由并跳转
      const targetRoute = getAndClearTargetRoute();

      // 显示成功提示，但设置较短的超时时间
      console.log(store.state.auth?.registrationBonus);
      if (store.state.auth?.registrationBonus?.register_send_amount) {
        showSuccess(
          "Entrar realizado com sucesso,Recompensas de presente" +
            (
              store.state.auth?.registrationBonus?.register_send_amount / 100
            ).toFixed(0),
          1500
        );
      } else {
        showSuccess("Entrar realizado com sucesso", 1500);
      }

      // 延迟路由跳转，确保 Toast 能够正常显示
      setTimeout(() => {
        if (targetRoute) {
          router.push(targetRoute);
        }
      }, 500);

      // await loginDevice({ }).send();
    } else {
      // showError("Falha ao fazer login");
    }
  } catch (error: any) {
    console.log(error);
    // showError(error || "Falha ao fazer login");
  } finally {
    loading.value = false;
  }
};
// 处理登录
const handleLogin = async () => {
  if (isPasswordLogin.value) {
    if (!validatePassword(password.value) || !validatePhone(phone.value)) {
      return;
    }
  } else {
    if (!validatePhone(phone.value) || !validateCode(verificationCode.value)) {
      return;
    }
  }
  console.log(134124214);
  try {
    loading.value = true;
    const { deviceId } = await generateDeviceFingerprint();
    const fingerprint = md5Encrypt(deviceId);
    const Fingerprint: any = localStorage.getItem("Fingerprint");
    let params: any = {
      phone: isPasswordLogin.value ? "" : phone.value,
      account_name: phone.value,
      password: password.value,
      code: verificationCode.value || "000000",
      login_method: isPasswordLogin.value ? 4 : 1, // 密码登录
      source: getDeviceCode(),
      md5: fingerprint,
      fingerprint: {
        request_id: JSON.parse(Fingerprint).requestId,
        visitor_id: JSON.parse(Fingerprint).visitorId,
      },
    };
    // 判断是否有活动id
    if (Number(activityObj.value?.activity_id)) {
      params.activity_id = parseInt(activityObj.value?.activity_id as string);
      params.source_code = activityObj.value?.invite_code;
    }
    // 判断是否有渠道id
    if (activityObj.value?.channel) {
      params.channel = localStorage.getItem("inviteCode");
    }

    // 判断是否有代理商邀请码
    if (activityObj.value?.agent_invite_code) {
      params.agent_invite_code = activityObj.value?.agent_invite_code;
    }

    const success = await store.dispatch("auth/login", params);
    if (success) {
      // 保存密码到本地存储（如果勾选了记住密码）
      savePasswordToStorage();

      // Reset form
      phone.value = "";
      password.value = "";
      confirmPassword.value = "";
      countdown.value = 0;
      // Close dialog
      emit("update:modelValue", false);
      emit("login");
      handleClose();
      // 触发登录成功事件
      eventBus.emit(LOGIN_EVENTS.LOGIN_SUCCESS);
      if (
        !activityObj.value?.pdd_invite_code &&
        localStorage.getItem("inviteCode")
      ) {
        localStorage.removeItem("inviteCode");
      }
      localStorage.setItem("isLogin", "true");
      // 获取目标路由并跳转
      const targetRoute = getAndClearTargetRoute();

      // 显示成功提示，但设置较短的超时时间

      showSuccess("Entrar realizado com sucesso", 1500);
      // 延迟路由跳转，确保 Toast 能够正常显示
      setTimeout(() => {
        if (targetRoute) {
          router.push(targetRoute);
        }
      }, 500);

      // await loginDevice({ }).send();
    } else {
      // showError("Falha ao fazer login");
    }
  } catch (error: any) {
    console.log(error);
    // showError(error || "Falha ao fazer login");
  } finally {
    loading.value = false;
  }
};

// 关闭弹窗
const handleClose = () => {
 
  show.value = false;
  // 如果没有勾选记住密码，清空表单
  if (!rememberChecked.value) {
    phone.value = "";
    password.value = "";
  }
  verificationCode.value = "";
  newPassword.value = "";
  confirmNewPassword.value = "";
  confirmPassword.value = "";
  activeTab.value = "phone";
  countdown.value = 0;
  isForgotPasswordMode.value = false;
  isSignUpMode.value = false;
  toggleModeBtn.value = "login";
};

const activityBtn = () => {
  if (isForgotPasswordMode.value) {
    if (
      phone.value &&
      verificationCode.value &&
      newPassword.value &&
      confirmNewPassword.value
    ) {
      return true;
    } else {
      false;
    }
  } else if (isSignUpMode.value) {
    if (phone.value && password.value && confirmPassword.value) {
      return true;
    } else {
      return false;
    }
  } else if (!isSignUpMode.value) {
    if (phone.value && password.value) {
      return true;
    } else {
      return false;
    }
  } else {
    false;
  }
};
</script>

<style lang="scss" scoped>
:deep(.v-label) {
  opacity: 0.3;
}
.login-dialog {
  :deep(.v-overlay__content) {
    border-radius: 28px;
    overflow: hidden;
  }

  .close-btn {
    height: 22px;
    width: 22px;
    text-align: right;
    background: #c9cad8 !important;
    color: #2b324d;
    margin-top: 10px;

    :deep(.v-icon) {
      font-size: 18px;
    }
  }
}

.login-card {
  background: url("@/assets/images/login-bg.png") no-repeat left #2b324d;
  background-size: 100% 100%;
  height: 429px;
  padding: 0 20px 0 515px;
  position: relative;

  &.mobile {
    // background: #2b324d !important;
    height: 560px;
    background: url("@/assets/images/mobile-login.png") no-repeat left #2b324d;
    background-size: 100% 100%;
    padding: 0 20px;
  }
}

.dialog-header {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 24px;

  span {
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;

    &:first-child {
      position: relative;

      &::after {
        content: "";
        position: absolute;
        bottom: -4px;
        left: 0;
        width: 100%;
        height: 2px;
        background: #ffdf00;
      }
    }
  }
}

.login-tabs {
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  .login-title-forget {
    line-height: 32px;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .login-title {
    width: 100%;
    height: 32px;
    line-height: 32px;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    font-weight: 600;

    // margin-bottom: 10px;
    cursor: pointer;
    width: 120px;
    text-transform: none !important;
  }
  .login-title-sign,
  .login-title-login {
    background: none !important;
    border-radius: 16px !important;
    box-shadow: none;
  }
  .activeTabBg {
    background: url("@/assets/images/login--title-btn.png") no-repeat !important;
    background-size: 100% 100% !important;
  }
  .tab-btn {
    width: auto;
    height: 40px;
    // 
    font-weight: 600;
    font-size: 12px;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    text-transform: none;
    position: relative;
    padding: 0;
    margin-bottom: 20px;

    :deep(.v-btn__overlay) {
      display: none !important;
      opacity: 0 !important;
    }

    &::after {
      display: none !important;
    }

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0 !important;
      height: 2px;
      border-radius: 2px !important;
      background: #ffdf00;
      transition: width 0.3s ease;
    }

    &:hover {
      background: none !important;

      &::before {
        width: 40px !important;
      }
    }

    &.active {
      color: white;

      &::before {
        width: 100% !important;
      }
    }
  }
}

.code-input-wrapper {
  position: relative;
  margin-bottom: 16px;

  .lock-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
  }

  // .code-input {
  //   :deep(.v-field) {
  //     .v-field__input {
  //       padding-left: 40px; // 为图标留出空间
  //     }
  //   }
  // }
}

.phone-input,
.code-input {
  margin-bottom: 10px;
  color: #ffdf00 !important;

  :deep(.v-field) {
    border-radius: 12px;
    background: #111827;

    .v-field__input {
      color: white !important;
      min-height: 44px !important;
      padding-left: 12px;
      font-size: 14px;
    }

    .prefix {
      margin-right: 8px;
      font-weight: 500;
      color: #ffdf00 !important;
    }

    .v-field__outline {
      border: none !important;
    }

    .v-field__prepend-inner {
      width: 40px;
      padding-top: 0;
      line-height: 45px;
    }

    input::placeholder {
      color: rgba(255, 255, 255, 0.6);
      font-size: 14px;
    }

    .v-field__append-inner {
      padding-top: 0;
    }
  }
}

.send-code-btn {
  font-size: 14px;
  text-transform: none;
  height: 45px !important;
  line-height: 45px;
  padding-top: 0 !important;
  color: #ffdf00 !important;
}

.remember-forgot {
  width: 100%;
  height: 20px;
  color: #49c973;
  font-weight: 500 !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;

  .remember-checkbox {
    min-height: 20px !important;
    height: 20px !important;
    font-size: 12px;

    :deep(.v-input__control) {
      height: 20px !important;

      .v-selection-control__input {
        width: 20px !important;
        height: 20px !important;
      }

      .v-selection-control__wrapper {
        width: 20px !important;
        height: 20px !important;
      }

      .v-checkbox-btn {
        min-height: 20px !important;
        height: 20px !important;
      }

      .v-label--clickable {
        font-weight: 500;
        font-size: 12px;
      }
    }
  }

  .forgot-password {
    font-size: 12px;
    color: #49c973 !important;
  }
}
.tips-checkbox {
  :deep(.v-label) {
    font-size: 0.8rem !important;
    display: flex;
    text-align: left;
  }

  :deep(.v-selection-control) {
    align-items: flex-start;
    .v-selection-control__input {
    }
    .v-label {
      color: #eee !important;
    }
    .v-selection-control__wrapper {
    }

    .v-checkbox-btn {
    }

    .v-label--clickable {
    }
  }
}
.show-pass-btn {
  width: 30px !important;
  font-size: 14px;
  text-transform: none;
  height: 45px !important;
  line-height: 45px;
  padding-top: 0 !important;
  text-align: center;
  min-width: 10px !important;
}

.clear-btn {
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
  margin-right: 4px;
}

.clear-btn:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.sing-up-bottom {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #696969;
  text-align: center;
  margin-top: 5px;
  font-size: 12px;

  .sign-up-btn {
    color: #49c973;
    cursor: pointer;
  }
}

.login-btn {
  height: 48px !important;
  // background: linear-gradient(#429000 0%, #00a52e 100%);
  // box-shadow: inset 0px -4px 0px 0px #077f2b !important;
  background: url("@/assets/images/login-btn.png") no-repeat left #2b324d;
  background-size: 100% 100%;
  border-radius: 12px 12px 12px 12px;
  // border: 2px solid #01592b;
  // 
  font-weight: 600;
  font-size: 18px;
  color: #333333;
  line-height: 18px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-top: auto;
  margin-bottom: 0;
  // position: relative;

  // &::before {
  //   display: inline-block;
  //   position: absolute;
  //   content: "";
  //   width: 4px;
  //   height: 20px;
  //   background: #01592b;
  //   border-radius: 0px 5px 5px 0px;
  //   top: 12px;
  //   left: 0px;
  // }
  // &::after {
  //   display: inline-block;
  //   position: absolute;
  //   content: "";
  //   width: 4px;
  //   height: 20px;
  //   background: #01592b !important;
  //   border-radius: 5px 0px 0px 5px;
  //   top: 12px;
  //   right: 0;
  //   opacity: 1 ;
  //   left: inherit ;
  // }
}
.active-login-btn {
  background: url("@/assets/images/login-btn-active.png") no-repeat left #2b324d;
  background-size: 100% 100%;
}
</style>
